import React, { useState, useEffect } from 'react';
import { Form } from 'react-bootstrap';

const GROOT_STYLE = 'padding: calc(var(--ukies-structure-padding-y) *2) var(--ukies-structure-padding-x)';

export default function UkiesSpacer({ componentSettings, setComponentSettings, onChange, selectedComponent }) {
    const [isInitialized, setIsInitialized] = useState(false);

    const format = componentSettings.format || 'normal';

    // Parse HTML content to extract spacer configuration
    const parseHTMLContent = (htmlContent) => {
        if (!htmlContent) return null;

        try {
            const parser = new DOMParser();
            const doc = parser.parseFromString(htmlContent, 'text/html');

            const mainDiv = doc.querySelector('.ukies-spacer');
            if (!mainDiv) return null;

            const style = mainDiv.getAttribute('style') || '';

            return {
                format: style.includes('--ukies-structure-padding-y') ? 'groot' : 'normal'
            };
        } catch (error) {
            console.error('Error parsing HTML content:', error);
            return null;
        }
    };

    // Generate HTML content from provided settings object
    const generateHTMLContentFromSettings = (settings) => {
        const settingsFormat = settings.format || 'normal';

        if (settingsFormat === 'groot') {
            return `<div class="ukies-spacer" style="${GROOT_STYLE}"></div>`;
        }

        return `<div class="ukies-spacer"></div>`;
    };

    // Initialize form values from HTML content on component mount
    useEffect(() => {
        if (selectedComponent?.content && !isInitialized) {
            const parsed = parseHTMLContent(selectedComponent.content);
            if (parsed) {
                setComponentSettings(prev => ({
                    ...prev,
                    format: parsed.format
                }));
            }
            setIsInitialized(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedComponent?.content, isInitialized, setComponentSettings]);

    // Reset initialization when component changes
    useEffect(() => {
        setIsInitialized(false);
    }, [selectedComponent?.id]);

    // Handle field changes and update HTML content
    const handleFieldChange = (fieldKey, value) => {
        const updatedSettings = { ...componentSettings, [fieldKey]: value };
        const newContent = generateHTMLContentFromSettings(updatedSettings);

        setComponentSettings(prev => ({
            ...prev,
            [fieldKey]: value,
            content: newContent
        }));

        onChange(fieldKey, value);
        onChange('content', newContent);
    };

    return (
        <div>
            <h6 className="mb-3 mt-3">
                Spacer
            </h6>

            <Form.Group className="mb-3">
                <Form.Label>Formaat</Form.Label>
                <Form.Select
                    value={format}
                    onChange={(e) => handleFieldChange('format', e.target.value)}
                >
                    <option value="normal">Normaal</option>
                    <option value="groot">Groot</option>
                </Form.Select>
            </Form.Group>
        </div>
    );
}
